import { useRef, useState } from "react";
import { ProfileViewImage } from "../../../../core/components/ProfileViewImage";
import { ProfileViewEditProps } from "../interfaces/ProfileViewEditInterface";
import { Column } from "../../../../core/components/Column";
import { CustomButton } from "../../../../core/components/CustomButton";

const ProfileViewEdit: React.FC<ProfileViewEditProps> = ({ Ref, selectImage, setSelectImage, handleIsSelected, handleEditStateImage, handleReplaceImage, isReplacingImage }) => {
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const replaceInputRef = useRef<HTMLInputElement>(null);

    const handleIsEdit = () => {
        setIsEdit(!isEdit);
    }

    const handleStateImage = (action: number) => {
        if (selectImage && setSelectImage && handleEditStateImage) {
            const updatedImage = {
                ...selectImage,
                state: action
            };
            setSelectImage(updatedImage);
            handleEditStateImage(updatedImage);
        }
    }

    const handleReplaceSelectedImage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        event.target.value = "";
        if (file && selectImage && handleReplaceImage) {
            handleReplaceImage(file, selectImage);
        }
    }

    return (
        <>
            <ProfileViewImage
                Ref={Ref}
                selectImage={selectImage?.url || ""}
                handleIsSelected={handleIsSelected}
            >
                {!selectImage?.is_profile &&
                    <CustomButton
                        onClick={handleIsEdit}
                        aria-label="Edit Image"
                        className="absolute top-14 sm:top-5 right-5"
                        small
                    >
                        Edit Options
                    </CustomButton>
                }
                {selectImage?.is_profile && handleReplaceImage &&
                    <>
                        <input
                            ref={replaceInputRef}
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={handleReplaceSelectedImage}
                        />
                        <CustomButton
                            onClick={() => replaceInputRef.current?.click()}
                            aria-label="Replace Image"
                            className="absolute top-14 sm:top-5 right-5"
                            small
                            loading={isReplacingImage}
                        >
                            Replace image
                        </CustomButton>
                    </>
                }
                {isEdit &&
                    <Column
                        className="w-full px-6 sm:px-12 absolute bottom-9 left-1/2 transform -translate-x-1/2 gap-3.5 font-semibold"
                    >
                        <CustomButton
                            color="white"
                            className="text-primary border-0"
                            onClick={() => handleStateImage(2)}
                        >
                            Set as my profile image
                        </CustomButton>
                        <CustomButton
                            color="white"
                            className="text-primary border-0"
                            onClick={() => handleStateImage(selectImage?.state === 1 ? 0 : 1)}
                        >
                            {selectImage?.state === 1 ? " Set to private" : " Set to public"}
                        </CustomButton>
                        <CustomButton
                            color="white"
                            className="text-primary border-0"
                            onClick={() => handleStateImage(-1)}
                        >
                            Delete
                        </CustomButton>
                        <CustomButton onClick={handleIsEdit}>
                            Cancel
                        </CustomButton>
                    </Column>
                }
            </ProfileViewImage>
        </>
    );
};

export default ProfileViewEdit;
